import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What does a vendor portal do?",
    answer: `<p>A supplier portal, also known as a vendor portal, is a useful online shared environment for businesses and their suppliers. The supplier portal allows suppliers to enter information and submit documents, as well as see statuses and share information.</p>`,
  },
  {
    question: "What is vendor development?",
    answer: `<p>Vendor development can be described as any activity in which a buying firm assists a supplier in improving its competency in such a way that it can meet the buying firm's supply input requirements.</p>`,
  },
  {
    question: "What is the cost of a vendor portal?",
    answer: ` <p>The average cost to implement a vendor portal is $70,000 to $150,000 based on the degree of portal functionality necessary.</p>`,
  },
  {
    question: "Can a vendor portal be accessed from a mobile device?",
    answer: `<p>Yes, our vendor portals are fully optimized with Mobile Devices in mind. This makes it possible for users to call, text, and access any relevant information at their time of preference, enhancing convenience.</p>`,
  },
  {
    question: "How secure is a supplier web portal solution?",
    answer: `<p>We prioritize security by using measures like encryption, user authentication, and routine security enhancements for optimal protection of your supplier web portal solution.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#f8f8f8" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                <span>Vendors Portal</span> Development FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
